import { useEffect, useState } from 'react';

export default function useThemeToggle() {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);

  const handleThemeChange = () => {
    if (theme === 'light') {
      setTheme('dark');
      localStorage.setItem('theme', theme);
    } else if (theme === 'dark') {
      setTheme('light');
      localStorage.setItem('theme', theme);
    }
  };

  const appendThemeCSS = (cssClassName) => {
    return cssClassName + ' ' + theme;
  };

  return { theme, handleThemeChange, appendThemeCSS };
}
